import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    children: [
      // Rotas serão adicionadas aqui
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
